// This browser's strikes and ban for writing a swastika in chat (see
// strikes.js), kept in localStorage next to the browser code (deviceId).
const LOCAL_STRIKES = "partycade.strikes";
const BLOCKED = "partycade.blocked";

function read(key) {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch {
    return null;
  }
}
function write(key, value) {
  try {
    if (value == null) localStorage.removeItem(key);
    else localStorage.setItem(key, JSON.stringify(value));
  } catch {}
}

// Counts one more strike on this browser and returns the total.
export function addLocalStrike() {
  const n = (Number(read(LOCAL_STRIKES)) || 0) + 1;
  write(LOCAL_STRIKES, n);
  return n;
}

// Bans this browser. `db`: the account ban (bans/users/{uid}) was saved too.
export const blockBrowser = (uid, db) => write(BLOCKED, { uid, at: Date.now(), db: !!db });

// Is this browser banned, for someone signed in as `uid`? `accountBanned` is
// whether bans/users/{uid} exists (null while checking). Once the owner lifts
// the ban of the account that was banned, this browser is unblocked for it
// (and its strikes here start over); other accounts here stay blocked.
export function blockedHere(uid, accountBanned) {
  const block = read(BLOCKED);
  if (!block) return false;
  if (block.uid !== uid || !block.db) return true;
  if (accountBanned === false) {
    write(BLOCKED, null);
    write(LOCAL_STRIKES, null);
    return false;
  }
  return true;
}
